export enum FieldTypes {
  primaryData = 'primaryData',
  extendedData = 'extendedData',
}
